let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ljRXP")).then(() => parcelRequire('eoRvM'));